import gql from "graphql-tag";

const VRPSTATUS_QUERY = gql`
query VrpStatus($chapterId: String!){
    VRPStatus(chapterId: $chapterId){
    earnedCY
    orderedCY
    earnedNextCY
    orderedNextCY
  }
}`

export default VRPSTATUS_QUERY;